export interface AppConfig {
    AUTH0_API_BASE_URL: string;
    AUTH0_EAPP_API_BASE_URL: string;
    AUTH0_WARNING_TIMEOUT_IN_MINS: string;
    AUTH0_EXPIRE_TIMEOUT_MINS: string;
    AUTH0_COOKIE_NAME: string;
    AUTH0_COOKIE_DOMAIN: string;
    AUTH0_TIMEOUT_RETURN_URL: string;
    AUTH0_API_LOGIN_URL: string;
    AUTH0_CONFIG_CLIENT_ID: string;
    EZCOMPLETE_DASHBOARD_URL: string;
    BFF_API_BASE_URL: string;
    ALIDA_TERM_ID: string;
    ALIDA_CI_ID: string;
    EQUINET_SIGNOUT_URL: string;
    GTM_TERM_ID: string;
    GTM_CI_ID: string;
    HEAP_ANALYTICS_APP_ID: string;
    LEGAL_URL: string;
    PRIVACY_URL: string;
    SECURITY_URL: string;
    LEGAL_URL_FR: string;
    PRIVACY_URL_FR: string;
    SECURITY_URL_FR: string;
    SANDBOX_MODE: string;
    BFF_SUBSCRIPTION_KEY: string;
    BFF_SANDBOX_SUBSCRIPTION_KEY: string;    
}

export let appConfig: AppConfig;
export const updateAppConfig = (config: any) => {
    appConfig = config;
    Object.freeze(appConfig);
};